import { Component } from 'react';

// Evita la "pantalla negra": si una página lanza un error de render,
// se muestra un mensaje recuperable (con el componente que falló) en vez
// de dejar la app congelada.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    // Deja el detalle en consola para depurar en producción
    console.error('ErrorBoundary capturó:', error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null, info: null });
    }
  }

  render() {
    if (this.state.error) {
      const stack = (this.state.info?.componentStack || '').trim().split('\n').slice(0, 4).join('\n');
      return (
        <div className="mx-auto max-w-lg space-y-4 py-16 text-center">
          <h2 className="text-xl font-bold">Algo salió mal en esta pantalla</h2>
          <p className="text-sm text-slate-400">
            Ocurrió un error al mostrar esta sección. Puedes intentar de nuevo o recargar la página.
          </p>
          <pre className="overflow-x-auto rounded-lg border border-slate-800 bg-slate-900 p-3 text-left text-xs text-red-400">
            {String(this.state.error?.message || this.state.error)}
            {stack ? '\n\nComponente:\n' + stack : ''}
          </pre>
          <div className="flex justify-center gap-2">
            <button className="btn-ghost" onClick={() => this.setState({ error: null, info: null })}>
              Reintentar
            </button>
            <button className="btn-primary" onClick={() => window.location.reload()}>
              Recargar
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
